import { Link } from "gatsby"
import React from "react"

const PostCard = ({ type, post }) => {
  const { imgUrl, title, date, path = "", excerpt } = post

  return (
    <>
      {type === "grid" ? (
        <Link
          to={path}
          className="w-[32%] text-black pb-6 mb-[60px] bg-white cursor-pointer"
        >
          <img
            className="m-0 mb-[32px] w-full"
            src={imgUrl}
            loading="lazy"
            alt={title}
          />

          <div className="pl-[20px] w-[94%]">
            <h3 className="m-0 font-playfair font-black text-[21px]">
              {title}
            </h3>
            <p className="m-0 mb-[20px] font-ubuntu text-[12px] font-light lg:h-[14px]">
              {date}
            </p>
            <p className="m-0 font-ubuntu text-[14px] leading-[20px]">
              {excerpt}
            </p>
          </div>
        </Link>
      ) : (
        <Link
          to={path}
          className="w-full text-black pb-8 mb-[60px] bg-white cursor-pointer"
        >
          <img
            className="m-0 mb-[32px] h-[342px] w-full object-cover"
            src={imgUrl}
            loading="lazy"
            alt={title}
          />

          <div className="pl-[20px] w-[97%]">
            <h3 className="m-0 font-playfair font-black text-[21px]">
              {title}
            </h3>
            <p className="m-0 mb-[20px] font-ubuntu text-[12px] font-light lg:h-[14px]">
              {date}
            </p>
            <p className="m-0 font-ubuntu text-[14px] leading-[20px]">
              {excerpt}
            </p>
          </div>
        </Link>
      )}
    </>
  )
}

export default PostCard
